export default {
    listMailSendBulk: state => state.listBroadcast,
    listMailSendByBroadcastId: state => state.listMailSendByBroadcastId,
}